import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { ADVENTURE_GREEN, LINE_GRAY } from '../colors';
import { getMs, getPercent } from '../helpers/common';
import { heightMixin } from '../mixins/layout';
const ProgressBarContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${({
  $small
}) => $small ? '4px' : '8px'};
  ${heightMixin}
`;
const commonProgressStyles = css`
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;
const Background = styled.div`
  ${commonProgressStyles};
  background-color: ${({
  $backgroundColor
}) => $backgroundColor};
  width: 100%;
  z-index: 0;
  ${({
  $transparent
}) => $transparent && 'opacity: 0;'}
  ${({
  $roundedCorners
}) => $roundedCorners && 'border-radius: 6px;'}
`;
const Progress = styled.div`
  ${commonProgressStyles};
  width: ${({
  $width
}) => getPercent($width)};
  background: ${({
  $progressBarColor
}) => $progressBarColor};
  z-index: 1;
  transition: ${({
  $animate,
  $animationDuration
}) => $animate ? `width ${getMs($animationDuration)} ease-out` : 'none'};
  ${({
  $roundedCorners,
  $fullWidth
}) => /* prettier-ignore */
$roundedCorners && `
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      ${$fullWidth ? `
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      ` : `
        max-width: calc(100% - 4px);
      `}
  `}
`;
const ProgressBar = ({
  progress: progressProp,
  height,
  transparent = false,
  corners = false,
  small = false,
  animate = true,
  animationDuration = 800,
  backgroundColor = LINE_GRAY,
  progressBarColor = ADVENTURE_GREEN,
  ...props
}) => {
  const progress = useMemo(() => progressProp < 0 ? 0 : progressProp > 100 ? 100 : progressProp || 0, [progressProp]);
  return /*#__PURE__*/React.createElement(ProgressBarContainer, _extends({
    role: "progressbar",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    "aria-valuenow": progress,
    $height: height,
    $small: small
  }, props), /*#__PURE__*/React.createElement(Background, {
    $roundedCorners: !corners,
    $transparent: transparent,
    $backgroundColor: backgroundColor
  }), /*#__PURE__*/React.createElement(Progress, {
    $animate: animate,
    $animationDuration: animationDuration,
    $roundedCorners: !corners,
    $fullWidth: progress === 100,
    $width: progress,
    $progressBarColor: progressBarColor
  }));
};
export default ProgressBar;